import styled from 'styled-components';

export const MainWrapper = styled.div`
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  max-width: 312px;

  @media screen and (max-width: 767px) {
    width: 100%;
    margin-bottom: 24px;
  }
`;

export const OptionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 72px;
  border: 1px solid #e0e7ec;
  border-radius: 4px;
  background-color: #fff;
  margin-bottom: 16px;
  padding: 0 24px 0 16px;
`;

export const OptionTitle = styled.div`
  width: 200px;
  height: 16px;
  margin-bottom: 0;
  margin-top: 0;
  margin-left: 16px;
`;

export const OptionIcon = styled.div`
  width: 64px;
  height: 64px;
  margin-bottom: 21px;
`;

export const OptionRadio = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
`;

export const PageTitle = styled.div`
  height: 24px;
  margin-bottom: 0;
  margin-top: 0;
  width: 300px;

  :first-child {
    width: 500px;
    margin-bottom: 16px;
  }
`;
